import cart from "../dialog/cart-dialog";
// import { store } from "../local/cart";
import { $json } from "../axios";
import { Message } from "element-ui";
import { getLangPath } from "../i18n/getLang";
import store from "../local/cart";
const cartMixin = {
  methods: {
    // 弹出购物车弹框
    showCart(goodsDetails) {
      cart(goodsDetails);
    },
  },
  filters: {
    // 格式化临期 BBD 显示
    formatExpireDate(date) {
      if (!date) return "";
      const arr = date.split("-");
      return `${arr[2]}/${arr[1]}/${arr[0]}`;
    },
  },
};
const addMyCart = (product) => {
  return $json
    .post("/cart/api", {
      sku: product.sku,
      qty: product.qty,
    })
    .then((res) => {
      store.dispatch("INIT_CART_COUNT");
      return res
    })
    .catch((error) => {
      if (error.statusCode === 200) {
        Message({
          type: "error",
          message: error.msg,
        });
      } else {
        if (!error.data.qty) {
          let flag = store.commit("addLocalCart", product);
          if (flag) {
            Message({
              message: getLangPath() ? "添加成功" : "Successful",
              type: "success",
            });
          } else {
            Message({
              message: getLangPath() ? "添加失败" : "Failed",
              type: "error",
            });
          }
        }
      }
    });
};

export { cartMixin, addMyCart };



// WEBPACK FOOTER //
// ./resources/js/lib/mixins/cart.js